module.exports = __webpack_public_path__ + "img/Design10 Front.8971368d.png";